module.exports = __webpack_public_path__ + "static/media/faq-video-captions-es.f54b78fe.vtt";